import React from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import styled from "styled-components";
import { Button } from "../components";

interface Props extends WithTranslation {
  fullScreen?: boolean;
}

interface State {
  hasError: boolean;
}

class ErrorBoundary extends React.Component<Props, State> {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return (
        <Container fullScreen={this.props.fullScreen || false}>
          <Header>{this.props.t("error_occurred")}</Header>
          <Button
            color="red"
            onClick={() => window.location.reload()}
            style={{ margin: "1.5rem 0", width: "auto" }}
          >
            {this.props.t("refresh_page")}
          </Button>
        </Container>
      );
    }
    return this.props.children;
  }
}

const Container = styled.div<{ fullScreen: boolean }>`
  align-items: center;
  display: flex;
  flex-direction: column;
  height: ${({ fullScreen }) => (fullScreen ? "100vh" : "calc(100vh - 84px)")};
  justify-content: center;
  margin: auto;
  max-width: 570px;
`;

const Header = styled.h1`
  font-size: 2.5rem;
  font-weight: normal;
  margin: 0;
  text-align: center;
`;

export default withTranslation()(ErrorBoundary);
